import { IProductNutrient } from '~/types/product';

export const defaultNutrients: IProductNutrient = {
  added_sugars_in_gram: null,
  calories_in_kcal: null,
  carbohydrate_in_gram: null,
  cholesterol_in_milligram: null,
  fiber_in_gram: null,
  polyols_in_gram: null,
  protein_in_gram: null,
  salt_in_gram: null,
  saturated_fat_in_gram: null,
  serving_size: null,
  serving_unit: undefined,
  sodium_in_milligram: null,
  total_fat_in_gram: null,
  total_sugars_in_gram: null,
  trans_fat_in_gram: null,
};
